import React from "react";
import { useGlobalContext } from "../../utils/globalContext";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Ministry = ({ content }) => {
  const { Trans } = useGlobalContext();
  const { image, alt, text } = content;

  return (
    <div id="ministry">
      {image && <LazyLoadImage src={image?.url} alt={alt} effect="blur" />}
      <p className={`paragraph ${image ? "withImage" : ""}`}>
        <Trans>{text}</Trans>
      </p>
    </div>
  );
};

export default Ministry;
